import { render, staticRenderFns } from "./UserWelfare.vue?vue&type=template&id=f6c05a10&scoped=true"
import script from "./UserWelfare.vue?vue&type=script&lang=js"
export * from "./UserWelfare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c05a10",
  null
  
)

export default component.exports